export default "__VITE_ASSET__Cc8nk9YZ__"